import React, { useEffect, useState } from 'react';
import { useParams, useHistory, useNavigate } from 'react-router-dom';
import { db,storage } from '../FireBase'; // Import Firestore
import { collection, query, where, getDocs, doc, getDoc, addDoc,updateDoc, orderBy} from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL} from "firebase/storage";
import { Container, Table, Alert, Button, Modal, Form,Row,Col,Card ,Tab,Tabs} from 'react-bootstrap';
import { faEdit, faFaceAngry, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ToastAlert from '../components/ToastAlert';
import { Link } from 'react-router-dom';
import '../css/font.css';
import Loading from '../components/Loading';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FaBoxesPacking, FaNoteSticky, FaPrint } from 'react-icons/fa6';
import axios from 'axios';
import DiscontinueSchemeModal from '../components/DiscontinueSchemeModal';
import FileViewModal from '../components/FileViewModal';
import Newlogo from '../Asset.png'; // Adjust the path based on your project structure




const ProcessScheme = () => {
    const { id } = useParams(); // Get the scheme ID from the URL
    const [scheme, setScheme] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('success');
    const navigate = useNavigate(); // Initialize useNavigate
    const [paidcustomers, setPaidCustomers] = useState([]); 
    const [customers, setCustomers] = useState([]); 
    const [Unpaidcustomers, setUnpaidCustomers] = useState([]); 
    const [products, setProducts] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [selectedCustomerDis, setSelectedCustomerDis] = useState(null);
    const [scannedBarcodes, setScannedBarcodes] = useState({});
    const [barcodeError, setBarcodeError] = useState('');
    const [packedOrders, setPackedOrders] = useState([]);
    const [billedOrders, setBilledOrders] = useState([]);
    const [processedOrders,setProcessedOrders] = useState([]);
    
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [orderNotes, setOrderNotes] = useState('');
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [billingUsers, setBillingUsers] = useState([]);
    const [logisticsUsers, setLogisticsUsers] = useState([]);
    const [selectedBillingUser, setSelectedBillingUser] = useState([]);
    const [selectedLogisticsUser, setSelectedLogisticsUser] = useState([]);
    const [selectedCompletedUsers, setSelectedCompletedUsers] = useState([]);
    const [activeTab, setActiveTab] = useState('paidcustomers');
    const [activeTab2, setActiveTab2] = useState('billed');
    const [currentUser, setCurrentUser] = useState(null);
    const [trackingLink, setTrackingLink] = useState('');
    const [uploadedSlip, setUploadedSlip] = useState(null);
    const [uploadedSlipURL, setUploadedSlipURL] = useState('');
    const [notPackedOrders,setNotPackedOrders] = useState('');
    const [notBilledOrders,setNotBilledOrders] = useState('');
    const [totalProducts, setTotalProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [scannedQuantities, setScannedQuantities] = useState({});
    
    const [contactDetails, setContactDetails] = useState({});
    const [showDiscontinueModal, setShowDiscontinueModal] = useState(false);
    const [showFileModal,setFileModal] =useState(false);
    const [proofUrl,setProofUrl] = useState('');
    const [disNotes,setDisNotes] = useState('');
    const [selectedPriceRanges, setSelectedPriceRanges] = useState({});

   

   

  
    useEffect(() => {
        fetchData();
    }, [id]);

    const fetchData = async () => {
        await fetchNotPackedOrders();
        await fetchPaidCustomers();
        await fetchPackedOrders();
        await fetchCustomers();
        await fetchSchemeDetails();
        await fetchProductDetails();
        await fetchUnpaidCustomers();
        await fetchBillingUsers();
        await fetchLogisticsUsers();
        await fetchBilledOrders();
        await fetchCurrentUser();
        await fetchProcessedOrders();
        await fetchContactDetails();
    };
    const syncData =async()=>{
        setToastMessage("Synchronization!!!");
        setToastVariant('warning');
        setShowToast(true);
        await fetchData();
        setToastMessage("Synchronization Complete!!!");
        setToastVariant('success');
        setShowToast(true);
        
    }
    const fetchBillingUsers = async () => {
        try {
            const billingQuery = query(collection(db, 'crm_users'), where('role', '==', 'Billing'));
            const billingSnapshot = await getDocs(billingQuery);
            const billingData = billingSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setBillingUsers(billingData);
        } catch (error) {
            console.error('Error fetching billing users:', error);
        }
    };

    const fetchLogisticsUsers = async () => {
        try {
            const logisticsQuery = query(collection(db, 'crm_users'), where('role', '==', 'Logistics'));
            const logisticsSnapshot = await getDocs(logisticsQuery);
            const logisticsData = logisticsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setLogisticsUsers(logisticsData);
        } catch (error) {
            console.error('Error fetching logistics users:', error);
        }
    };
    const fetchCurrentUser = async () => {
        try {
            const storedUser = JSON.parse(sessionStorage.getItem('user')); // Assuming the user object is stored as a JSON string
            if (storedUser && storedUser.uid) {
                const userRef = doc(db, 'crm_users', storedUser.uid);
                const userDoc = await getDoc(userRef);
                if (userDoc.exists()) {
                    setCurrentUser({ id: userDoc.id, ...userDoc.data() });
                } else {
                    console.log('No such user document!');
                }
            }
        } catch (error) {
            console.error('Error fetching current user:', error);
        }
    };

    const handleShowAssignModal = () => {
        setShowAssignModal(true);
    };

    const handleCloseAssignModal = () => {
        setShowAssignModal(false);
        setSelectedBillingUser([]);
        setSelectedLogisticsUser([]);
    };

    const handleAssignSubmit = async () => {
        try {
            // Handle the assignment logic here
            // For example, update the Firestore document with the selected billing and logistics users
            console.log('Selected Completed Users:', selectedCompletedUsers);
            console.log('Selected Billing User:', selectedBillingUser);
            console.log('Selected Logistics User:', selectedLogisticsUser);
            
               // Fetch user names for billing and logistics
            const billingUserDoc = await getDoc(doc(db, 'crm_users', selectedBillingUser));
            const logisticsUserDoc = await getDoc(doc(db, 'crm_users', selectedLogisticsUser));

            const billingUsername = billingUserDoc.exists() ? billingUserDoc.data().username : 'Unknown';
            const logisticsUsername = logisticsUserDoc.exists() ? logisticsUserDoc.data().username : 'Unknown';

                    // Update Firestore documents for each selected completed user
            for (const userId of selectedCompletedUsers) {
                const subscriptionQuery = query(collection(db, 'subscriptions'), where('userId', '==', userId), where('schemeId', '==', id));
                const subscriptionSnapshot = await getDocs(subscriptionQuery);
                if (!subscriptionSnapshot.empty) {
                    const subscriptionDoc = subscriptionSnapshot.docs[0];
                    const subscriptionRef = doc(db, 'subscriptions', subscriptionDoc.id);
                    await updateDoc(subscriptionRef, {
                        billingUserId: selectedBillingUser,
                        billingUsername: billingUsername,
                        logisticsUserId: selectedLogisticsUser,
                        logisticsUsername: logisticsUsername,
                        assignedBy: currentUser ? currentUser.username : 'Unknown',
                        billingStatus:"Assigned-for-billing",
                        PackingStatus:"Assigned"
        
                    });
                    console.log("update scheme collections")
                }
            }
    
            // Close the modal and show a success message
            handleCloseAssignModal();
            setToastMessage('Users assigned successfully');
            setToastVariant('success');
            setShowToast(true);
            fetchData();
        } catch (error) {
            console.error('Error assigning users:', error);
            setToastMessage('Error assigning users. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
   

    const fetchSchemeDetails = async () => {
        try {
            const schemeRef = doc(db, 'schemes', id);
            const schemeDoc = await getDoc(schemeRef);
            if (schemeDoc.exists()) {
                const schemeData = { id: schemeDoc.id, ...schemeDoc.data() };
                setScheme(schemeData);
                fetchProductDetails(schemeData);
            } else {
                console.log('No such document!');
            }
        } catch (error) {
            console.error('Error fetching scheme details:', error);
            
        }
    };

    const fetchCustomers = async () => {
        try {
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs.map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    return { id: userDoc.id, ...userDoc.data() };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
          
        }
    };

    const fetchPaidCustomers = async () => {
        try {
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('deliveryStatus', '==', ''));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs
                .filter(doc => parseInt(doc.data().totalMonths) ===parseInt( doc.data().paidMonths))
                .map(doc => doc.data().userId);

            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    const subscriptionDoc = subscriptionsSnapshot.docs.find(doc => doc.data().userId === userId);
                    return { id: userDoc.id, ...userDoc.data(),  
                        billingUserId: subscriptionDoc.data().billingUserId,
                        logisticsUserId: subscriptionDoc.data().logisticsUserId,
                        quantity: subscriptionDoc.data().quantity,
                };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });

            const customersData = await Promise.all(customerPromises);
            setPaidCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
           
        }
    };

    const fetchUnpaidCustomers = async () => {
        try {
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('deliveryStatus', '!=', 'Processing'));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
            const userIds = subscriptionsSnapshot.docs
                .filter(doc => parseInt(doc.data().totalMonths) !== parseInt(doc.data().paidMonths))
                .map(doc => doc.data().userId);
    
            const customerPromises = userIds.map(async userId => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    const subscriptionDoc = subscriptionsSnapshot.docs.find(doc => doc.data().userId === userId);
                    return {
                        id: userDoc.id,
                        ...userDoc.data(),
                        schemeId: subscriptionDoc.data().schemeId,
                        totalMonths: subscriptionDoc.data().totalMonths,
                        paidMonths: subscriptionDoc.data().paidMonths,
                        deliveryStatus: subscriptionDoc.data().deliveryStatus,
                        discontinueData: subscriptionDoc.data().discontinueData,
                        status: subscriptionDoc.data().status,
                    };
                } else {
                    console.log(`No such user document for userId: ${userId}`);
                    return null;
                }
            });
    
            const customersData = await Promise.all(customerPromises);
            console.log(customersData);
            setUnpaidCustomers(customersData.filter(customer => customer !== null));
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };



    const fetchProductDetails = async (schemeData) => {
        try {
            if (schemeData && schemeData.productDetails) {
                const productPromises = schemeData.productDetails.map(async product => {
                    const productRef = doc(db, 'products', product.productId);
                    const productDoc = await getDoc(productRef);
                    if (productDoc.exists()) {
                        const productData = productDoc.data();
                        return {
                            id: productDoc.id,
                            ...productData,
                            quantity: product.quantity,
                            priceRanges: productData.priceRanges || [], // Include price ranges
                        };
                    } else {
                        console.log(`No such product document for productId: ${product.productId}`);
                        return null;
                    }
                });
    
                const productsData = await Promise.all(productPromises);
                setProducts(productsData.filter(product => product !== null));
            }
        } catch (error) {
            console.error('Error fetching product details:', error);
        }
    };

    const fetchPackedOrders = async () => {
        try {
            const packedOrdersQuery = query(collection(db, 'order-processing'), where('PackingStatus', '==', 'Packed'), where('schemeId', '==', id));
            const packedOrdersSnapshot = await getDocs(packedOrdersQuery);
            const packedOrdersData = packedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPackedOrders(packedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    const fetchNotPackedOrders = async () => {
        try {
            const packedOrdersQuery = query(collection(db, 'order-processing'), where('PackingStatus', '==', 'Assigned-for-packing'), where('schemeId', '==', id));
            const packedOrdersSnapshot = await getDocs(packedOrdersQuery);
            const packedOrdersData = packedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setNotPackedOrders(packedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    const fetchBilledOrders = async () => {
        try {
            console.log(id)
            const billedOrdersQuery = query(collection(db, 'order-processing'), where('BillingStatus', '==', 'Billed'),where('PackingStatus','==','Assigned-for-packing'), where('schemeId', '==', id),orderBy('createdAt','desc'));
            const billedOrdersSnapshot = await getDocs(billedOrdersQuery);
            const billedOrdersData = billedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setBilledOrders(billedOrdersData);
            console.log(billedOrdersData)
            console.log("fetching billed orders");
        } catch (error) {
            console.error('Error fetching billed orders:', error);
          
        }
    };
 
    const fetchProcessedOrders = async () => {
        try {
            const processedOrdersQuery = query(collection(db, 'order-processing'), where('PackingStatus', '==', 'Packed'), where('schemeId', '==', id));
            const processedOrdersSnapshot = await getDocs(processedOrdersQuery);
            const processedOrdersData = processedOrdersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setProcessedOrders(processedOrdersData);
        } catch (error) {
            console.error('Error fetching packed orders:', error);
          
        }
    };
    
    const handleShowModal = (customer) => {
        setSelectedCustomer(customer);
        const totalProducts = products.map(product => ({
            ...product,
            totalQuantity: customer.quantity * product.quantity
        }));
        setTotalProducts(totalProducts);
        setShowModal(true);
    };
    const handleCloseModal = () => {
        setScannedQuantities({});
        setShowModal(false);
        setSelectedCustomer(null);
        setScannedBarcodes({});
        setBarcodeError('');
    };

    const handleBarcodeChange = (productId, barcode) => {
        const product = totalProducts.find(product => product.id === productId);
        if (barcode === product.barcode) {
            if ((scannedQuantities[productId] || 0) < product.totalQuantity) {
                setScannedQuantities(prevState => ({
                    ...prevState,
                    [productId]: (prevState[productId] || 0) + 1
                }));
                setScannedBarcodes(prevState => ({
                    ...prevState,
                    [productId]: ''
                }));
            } else {
                setToastMessage(`Scanned quantity for product: ${product.name} cannot exceed total quantity`);
                setToastVariant('danger');
                setShowToast(true);
            }
        } else {
            setScannedBarcodes(prevState => ({
                ...prevState,
                [productId]: barcode
            }));
        }
    };
    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            const invoiceNumber = `INV-${Date.now()}`; // Example: Use timestamp for unique invoice number
            for (const product of totalProducts) {
                const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                if (selectedPriceRangeIndex === undefined) {
                    setToastMessage(`Please select a price range for product: ${product.name}`);
                    setToastVariant('danger');
                    setShowToast(true);
                    setIsLoading(false);
                    return;
                }
    
                const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                if ((scannedQuantities[product.id] || 0) < product.totalQuantity) {
                    setToastMessage(`Insufficient scanned quantity for product: ${product.name}`);
                    setToastVariant('danger');
                    setShowToast(true);
                    setBarcodeError(`Insufficient scanned quantity for product: ${product.name}`);
                    setIsLoading(false);
                    return;
                }
    
                if (selectedPriceRange.stock < product.totalQuantity) {
                    setToastMessage(`Insufficient stock for product: ${product.name} at price: ${selectedPriceRange.price}`);
                    setToastVariant('danger');
                    setShowToast(true);
                    setIsLoading(false);
                    return;
                }
            }
    
            // Update stock quantity in the products collection
        // Update stock quantity in the products collection
               // Update stock quantity in the products collection
// Update stock quantity in the products collection
        for (const product of totalProducts) {
            const selectedPriceRangeIndex = selectedPriceRanges[product.id]; // Get selected price range index
            if (selectedPriceRangeIndex === undefined) {
                console.error(`No price range selected for product: ${product.name}`);
                continue;
            }

            const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex]; // Get selected price range
            if (!selectedPriceRange) {
                console.error(`Price range index out of bounds for product: ${product.name}`);
                continue;
            }

            console.log(`Updating stock for ${product.name}, Price: ${selectedPriceRange.price}, Current Stock: ${selectedPriceRange.stock}, Deducting: ${product.totalQuantity}`);

            // Deduct stock only for the selected price range
            const updatedPriceRanges = product.priceRanges.map((priceRange) =>
                priceRange.price === selectedPriceRange.price
                    ? { 
                        ...priceRange, 
                        stock: Math.max(priceRange.stock - product.totalQuantity, 0), 
                        mrp: priceRange.mrp ?? selectedPriceRange.mrp  // Ensure MRP is not removed
                      }
                    : priceRange
            );
            

            // Check if stock is actually updated
            console.log(`Updated price ranges for ${product.name}:`, updatedPriceRanges);

            try {
                // Update Firestore with the modified priceRanges
                const productRef = doc(db, 'products', product.id);
                await updateDoc(productRef, {
                    priceRanges: updatedPriceRanges
                });
              // Log the stock update
            const stockData = {
                productId: product.id,
                priceRanges: [{mrp:selectedPriceRange.mrp,price:selectedPriceRange.price, stock:product.totalQuantity}],
                updatedAt: new Date(),
                customerId: selectedCustomer.cusmid,
                schemeId: scheme.id,
                schemeName: scheme.name,
                type: 'Outward-stock',
            };
            await addDoc(collection(db, 'stock-management'), stockData);
       
                console.log(`Stock successfully updated for ${product.name}`);
            } catch (error) {
                console.error(`Error updating stock for ${product.name}:`, error);
            }
        }
            // Add delivery status in the subscriptions collection
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('schemeId', '==', id), where('userId', '==', selectedCustomer.cusmid));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);
    
            if (!subscriptionsSnapshot.empty) {
                const subscriptionDoc = subscriptionsSnapshot.docs[0];
                const subscriptionRef = doc(db, 'subscriptions', subscriptionDoc.id);
                await updateDoc(subscriptionRef, {
                    invoiceNumber:invoiceNumber,
                    deliveryStatus: 'Processing',
                    deliveryStatuscreatedAt: new Date(),
                    billingUser: currentUser ? currentUser.username : 'Unknown',
                    billingStatus: 'Billed',
                    PackingStatus: 'Assigned-for-packing',
                });
            }
    
            // Generate delivery slip content
            
            const pdfDoc = new jsPDF();

            // Generate Invoice Number
          
    
            // Calculate Total Bill Value
            let totalBillValue = 0;
            totalProducts.forEach(product => {
                const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                if (selectedPriceRange) {
                    totalBillValue += product.totalQuantity * selectedPriceRange.price;
                }
            });
    
            // Calculate Total Savings
            const totalSavings = scheme?.totalSchemeValue - totalBillValue;
    
            // Add the logo
            //  const logoUrl = `${process.env.PUBLIC_URL}/logo-full.png`; // Logo path
            const logoWidth = 40;   // Adjusted width for better layout
            const logoHeight = 40; // Adjusted height (assuming square logo)
            const logoX = 10;
            const logoY = 10;
            pdfDoc.addImage(Newlogo, 'PNG', logoX, logoY, logoWidth, logoHeight);
    // Title next to the logo
            const titleX = logoX + logoWidth + 10; // Space after logo
            const titleY = logoY + 12; // Vertically align with logo
            // Add title next to the logo
         
           // Set font for the heading
            pdfDoc.setFontSize(22);
            pdfDoc.setFont('helvetica', 'bold');

            // Get the page width
            const pageWidth = pdfDoc.internal.pageSize.getWidth();

            // Define the text
            const invoiceTitle = 'Invoice';

            // Measure the text width
            const textWidth = pdfDoc.getTextWidth(invoiceTitle);

            // Calculate X position to center the text
            const centerX = (pageWidth - textWidth) / 2;

            // Add the centered Invoice text below the logo/title
            pdfDoc.text(invoiceTitle, centerX, titleY + 10);
            // Add date and invoice number on the top-right
            pdfDoc.setFontSize(12);
            const dateX = 200;
            const dateY = 15;
            pdfDoc.text(`Date: ${new Date().toLocaleString()}`, dateX, dateY, { align: 'right' });
            pdfDoc.text(`Invoice No: ${invoiceNumber}`, dateX, dateY + 10, { align: 'right' });
    
            // Add store address and delivery address on the same row
            const addressStartY = 50; // Start below the logo and title
            pdfDoc.setFontSize(12);
    
            // Store Address
            pdfDoc.text('Store Address:', 10, addressStartY);
            const splitStoreAddress = pdfDoc.splitTextToSize(contactDetails.address || 'Not Available', 80);
            pdfDoc.text(splitStoreAddress, 10, addressStartY + 5);
            const storeAddressHeight = splitStoreAddress.length * 5;
            const contactStoreStartY = addressStartY + storeAddressHeight + 5;
            pdfDoc.text(`Phone: ${contactDetails.phone || 'Not Available'}`, 10, contactStoreStartY);
            pdfDoc.text(`Email: ${contactDetails.email || 'Not Available'}`, 10, contactStoreStartY + 5);
    
            // Delivery Address
            const deliveryAddressStartX = 110; // Align delivery address to the right
            pdfDoc.text('Delivery Address:', deliveryAddressStartX, addressStartY);
            pdfDoc.text(`${selectedCustomer?.name || 'Not Available'}`, deliveryAddressStartX, addressStartY + 5);
            const deliveryAddress = `${selectedCustomer?.address?.address || ''}, ${selectedCustomer?.address?.city || ''}, ${selectedCustomer?.address?.state || ''}, ${selectedCustomer?.address?.country || ''}, ${selectedCustomer?.address?.postalCode || ''}`;
            const splitDeliveryAddress = pdfDoc.splitTextToSize(deliveryAddress, 80);
            pdfDoc.text(splitDeliveryAddress, deliveryAddressStartX, addressStartY + 10);
            const deliveryAddressHeight = splitDeliveryAddress.length * 5;
            const contactDeliveryStartY = addressStartY + Math.max(storeAddressHeight, deliveryAddressHeight) + 10;
            pdfDoc.text(`Phone: ${selectedCustomer?.phone || 'Not Available'}`, deliveryAddressStartX, contactDeliveryStartY);
            pdfDoc.text(`Email: ${selectedCustomer?.email || 'Not Available'}`, deliveryAddressStartX, contactDeliveryStartY + 5);
    
            // Add scheme details
            const schemeDetailsStartY = contactDeliveryStartY + 15; // Ensure proper spacing
            pdfDoc.text(`Scheme Name: ${scheme?.name || 'Not Available'}`, 10, schemeDetailsStartY);
            pdfDoc.text(`Scheme Value: ${scheme?.totalSchemeValue || 0}`, 10, schemeDetailsStartY + 5);
    
            // Prepare product details for the table
            const productRows = totalProducts.map(product => {
                const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                const totalPrice = product.totalQuantity * (selectedPriceRange?.mrp || 0);
                return [
                    product.name,
                    `${product.unitValue} ${product.unitType}`,
                    product.totalQuantity,
                    `${selectedPriceRange?.mrp || 0}`,
                    `${totalPrice}`,
                ];
            });
    
            // Add Total Bill Value and Savings as rows in the table
            productRows.push([
                { content: 'Total Bill Value', colSpan: 4, styles: { halign: 'right', fontStyle: 'bold' } },
                { content: `${totalBillValue.toFixed(2)}`, styles: { fontStyle: 'bold' } },
            ]);
            pdfDoc.setFont(undefined, 'bold'); // Set bold font
            productRows.push([
                {
                  content: 'Total Savings',
                  colSpan: 4,
                  styles: {
                    halign: 'right',
                    fontStyle: 'bold',
                    textColor: '#2e7d32',      // Dark green
                    fillColor: '#e8f5e9',      // Light green background
                  },
                },
                {
                  content: `${totalSavings.toFixed(2)}`,
                  styles: {
                    fontStyle: 'bold',
                    textColor: '#2e7d32',
                    fillColor: '#e8f5e9',
                  },
                },
              ]);
              
            pdfDoc.setFont(undefined, 'normal');
            // Add product details table
            const productDetailsStartY = schemeDetailsStartY + 15;
            pdfDoc.text('Products:', 10, productDetailsStartY);
            pdfDoc.autoTable({
                startY: productDetailsStartY + 5,
                head: [['Product Name', 'Measurement', 'Quantity', 'Price', 'Total']],
                body: productRows,
                styles: { fontSize: 10, cellPadding: 2 },
            });
    
            // Add signature spaces
            const finalY = pdfDoc.lastAutoTable.finalY + 20;
            pdfDoc.text(`Billing Person : ${currentUser?.username || 'Unknown'}`, 10, finalY);
            pdfDoc.text(`Packing Person : ${currentUser?.username || 'Unknown'}`, 110, finalY);
            
            // Open the PDF in a new tab
            const pdfBlob = pdfDoc.output('blob');
            const storageRef = ref(storage, `deliverySlips/${selectedCustomer.cusmid}_${id}.pdf`);
            await uploadBytes(storageRef, pdfBlob);
            const deliverySlipURL = await getDownloadURL(storageRef);
            console.log(deliverySlipURL)
            await addDoc(collection(db, 'order-processing'), {
                customerId: selectedCustomer.cusmid,
                invoiceNumber:invoiceNumber,
                schemeId: scheme.id,
                products: totalProducts.map(product => {
                    const selectedPriceRangeIndex = selectedPriceRanges[product.id];
                    const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
                    console.log(selectedPriceRange)
                    return {
                        productId: product.id,
                        quantity: product.totalQuantity,
                        barcode: product.barcode,
                        price: selectedPriceRange.price,
                        mrp:selectedPriceRange?.mrp || 0
                    };
                }),
                deliveryStatus: 'Processing',
                BillingStatus: 'Billed',
                PackingStatus: 'Assigned-for-packing',
                billingUser: currentUser ? currentUser.username : 'Unknown',
                createdAt: new Date(),
                deliverySlipURL: deliverySlipURL
            });
            fetchData();
            handleCloseModal();
            setToastMessage('Delivery processed successfully');
            setToastVariant('success');
            setShowToast(true);
        } catch (error) {
            console.error('Error processing order:', error);
            setToastMessage('Error processing order. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        } finally {
            setIsLoading(false);
        }
    };
    const handleShowNotesModal = (order) => {
        setSelectedOrder(order);
        setOrderNotes(order.notes || '');
        setTrackingLink(order.trackingLink || '');
        setShowNotesModal(true);
        setUploadedSlipURL(order.slipURL || '');
    };

    const handleCloseNotesModal = () => {
        setShowNotesModal(false);
        setSelectedOrder(null);
        setOrderNotes('');
    };
    // const handlePreviewPDF = async () => {
    //     try {
    //         const pdfDoc = new jsPDF();

    //         // Generate Invoice Number
    //         const invoiceNumber = `INV-${Date.now()}`; // Example: Use timestamp for unique invoice number
    
    //         // Calculate Total Bill Value
    //         let totalBillValue = 0;
    //         totalProducts.forEach(product => {
    //             const selectedPriceRangeIndex = selectedPriceRanges[product.id];
    //             const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
    //             if (selectedPriceRange) {
    //                 totalBillValue += product.totalQuantity * selectedPriceRange.price;
    //             }
    //         });
    
    //         // Calculate Total Savings
    //         const totalSavings = scheme?.totalSchemeValue - totalBillValue;
    
    //         // Add the logo
    //         const logoUrl = `${process.env.PUBLIC_URL}/logo.png`; // Replace with your actual logo path
    //         const logoSize = 40; // Increase the logo size (square)
    //         pdfDoc.addImage(logoUrl, 'PNG', 10, 10, logoSize, logoSize); // Logo at top-left
    
    //         // Add title next to the logo
    //         pdfDoc.setFontSize(24);
    //         pdfDoc.text('PS-Stores', 70, 20); // Title next to the logo
    //         pdfDoc.setFontSize(18);
    //         pdfDoc.text('Delivery Challan', 70, 30); // Subtitle below the title
    
    //         // Add date and invoice number on the top-right
    //         pdfDoc.setFontSize(12);
    //         pdfDoc.text(`Date: ${new Date().toLocaleString()}`, 200, 20, { align: 'right' });
    //         pdfDoc.text(`Invoice No: ${invoiceNumber}`, 200, 30, { align: 'right' });
    
    //         // Add store address and delivery address on the same row
    //         const addressStartY = 50; // Start below the logo and title
    //         pdfDoc.setFontSize(12);
    
    //         // Store Address
    //         pdfDoc.text('Store Address:', 10, addressStartY);
    //         const splitStoreAddress = pdfDoc.splitTextToSize(contactDetails.address || 'Not Available', 80);
    //         pdfDoc.text(splitStoreAddress, 10, addressStartY + 5);
    //         const storeAddressHeight = splitStoreAddress.length * 5;
    //         const contactStoreStartY = addressStartY + storeAddressHeight + 5;
    //         pdfDoc.text(`Phone: ${contactDetails.phone || 'Not Available'}`, 10, contactStoreStartY);
    //         pdfDoc.text(`Email: ${contactDetails.email || 'Not Available'}`, 10, contactStoreStartY + 5);
    
    //         // Delivery Address
    //         const deliveryAddressStartX = 110; // Align delivery address to the right
    //         pdfDoc.text('Delivery Address:', deliveryAddressStartX, addressStartY);
    //         pdfDoc.text(`${selectedCustomer?.name || 'Not Available'}`, deliveryAddressStartX, addressStartY + 5);
    //         const deliveryAddress = `${selectedCustomer?.address?.address || ''}, ${selectedCustomer?.address?.city || ''}, ${selectedCustomer?.address?.state || ''}, ${selectedCustomer?.address?.country || ''}, ${selectedCustomer?.address?.postalCode || ''}`;
    //         const splitDeliveryAddress = pdfDoc.splitTextToSize(deliveryAddress, 80);
    //         pdfDoc.text(splitDeliveryAddress, deliveryAddressStartX, addressStartY + 10);
    //         const deliveryAddressHeight = splitDeliveryAddress.length * 5;
    //         const contactDeliveryStartY = addressStartY + Math.max(storeAddressHeight, deliveryAddressHeight) + 10;
    //         pdfDoc.text(`Phone: ${selectedCustomer?.phone || 'Not Available'}`, deliveryAddressStartX, contactDeliveryStartY);
    //         pdfDoc.text(`Email: ${selectedCustomer?.email || 'Not Available'}`, deliveryAddressStartX, contactDeliveryStartY + 5);
    
    //         // Add scheme details
    //         const schemeDetailsStartY = contactDeliveryStartY + 15; // Ensure proper spacing
    //         pdfDoc.text(`Scheme Name: ${scheme?.name || 'Not Available'}`, 10, schemeDetailsStartY);
    //         pdfDoc.text(`Scheme Value: ${scheme?.totalSchemeValue || 0}`, 10, schemeDetailsStartY + 5);
    
    //         // Prepare product details for the table
    //         const productRows = totalProducts.map(product => {
    //             const selectedPriceRangeIndex = selectedPriceRanges[product.id];
    //             const selectedPriceRange = product.priceRanges[selectedPriceRangeIndex];
    //             const totalPrice = product.totalQuantity * (selectedPriceRange?.price || 0);
    //             return [
    //                 product.name,
    //                 `${product.unitValue} ${product.unitType}`,
    //                 product.totalQuantity,
    //                 `${selectedPriceRange?.price || 0}`,
    //                 `${totalPrice}`,
    //             ];
    //         });
    
    //         // Add Total Bill Value and Savings as rows in the table
    //         productRows.push([
    //             { content: 'Total Bill Value', colSpan: 4, styles: { halign: 'right', fontStyle: 'bold' } },
    //             { content: `${totalBillValue.toFixed(2)}`, styles: { fontStyle: 'bold' } },
    //         ]);
    //         productRows.push([
    //             { content: 'Total Savings', colSpan: 4, styles: { halign: 'right', fontStyle: 'bold' } },
    //             { content: `${totalSavings.toFixed(2)}`, styles: { fontStyle: 'bold' } },
    //         ]);
    
    //         // Add product details table
    //         const productDetailsStartY = schemeDetailsStartY + 15;
    //         pdfDoc.text('Products:', 10, productDetailsStartY);
    //         pdfDoc.autoTable({
    //             startY: productDetailsStartY + 5,
    //             head: [['Product Name', 'Measurement', 'Quantity', 'Price', 'Total']],
    //             body: productRows,
    //             styles: { fontSize: 10, cellPadding: 2 },
    //         });
    
    //         // Add signature spaces
    //         const finalY = pdfDoc.lastAutoTable.finalY + 20;
    //         pdfDoc.text('Billing Person Signature:', 10, finalY);
    //         pdfDoc.text('Packing Person Signature:', 110, finalY);
    //         // Open the PDF in a new tab
    //         const pdfUrl = pdfDoc.output('bloburl');
    //         window.open(pdfUrl, '_blank');
    //     } catch (error) {
    //         console.error('Error generating PDF preview:', error);
    //         setToastMessage('Error generating PDF preview. Please try again.');
    //         setToastVariant('danger');
    //         setShowToast(true);
    //     }
    // };
    const handleNotesSubmit = async () => {
        try {
            if (selectedOrder) {
                const orderRef = doc(db, 'order-processing', selectedOrder.id);
                let slipURL = selectedOrder.slipURL || '';
    
                // Upload slip if a new file is selected
                if (uploadedSlip) {
                    const storageRef = ref(storage, `orderSlips/${selectedOrder.id}_${uploadedSlip.name}`);
                    await uploadBytes(storageRef, uploadedSlip);
                    slipURL = await getDownloadURL(storageRef);
                }
    
                // Query to find subscription related to this order
                const subscriptionQuery = query(
                    collection(db, 'subscriptions'),
                    where('userId', '==', selectedOrder.customerId)
                );
    
                const subscriptionSnapshot = await getDocs(subscriptionQuery);
                const updatePromises = [];
    
                // Update order-processing document
                updatePromises.push(updateDoc(orderRef, {
                    notes: orderNotes,
                    trackingLink: trackingLink,
                    slipURL: slipURL,
                    packageProcessedBy: currentUser ? currentUser.username : 'Unknown',
                    deliveryStatus: "Processed"
                }));
    
                // Update subscription document(s)
                if (!subscriptionSnapshot.empty) {
                    subscriptionSnapshot.docs.forEach(docSnap => {
                        const subscriptionRef = doc(db, 'subscriptions', docSnap.id);
                        updatePromises.push(updateDoc(subscriptionRef, {
                         
                            packageProcessedBy: currentUser ? currentUser.username : 'Unknown',
                            deliveryStatus: "Processed"
                        }));
                    });
                } else {
                    console.warn("No subscription found for this customer.");
                }
    
                // Execute all updates
                await Promise.all(updatePromises);
    
                // Update local state
                setPackedOrders(prevOrders =>
                    prevOrders.map(order =>
                        order.id === selectedOrder.id
                            ? { ...order, notes: orderNotes, trackingLink: trackingLink, slipURL: slipURL }
                            : order
                    )
                );
    
                fetchData();
                handleCloseNotesModal();
                setToastMessage('Order and subscription processed successfully');
                setToastVariant('success');
                setShowToast(true);
            }
        } catch (error) {
            console.error('Error updating order and subscription notes:', error);
            setToastMessage('Error updating order and subscription. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
    

    const handleMovePackOrder = async (order) => {
        try {
            if (order) {
                const orderRef = doc(db, 'order-processing', order.id);
                const subscriptionQuery = query(
                    collection(db, 'subscriptions'),
                    where('userId', '==', order.customerId)
                );
    
                // Fetch subscription document
                const subscriptionSnapshot = await getDocs(subscriptionQuery);
    
                const updatePromises = [];
    
                // Update order-processing document
                updatePromises.push(updateDoc(orderRef, {
                    PackingStatus: "Packed",
                    packedUser: currentUser ? currentUser.username : 'Unknown',
                }));
    
                // Update subscription document(s)
                if (!subscriptionSnapshot.empty) {
                    subscriptionSnapshot.docs.forEach(docSnap => {
                        const subscriptionRef = doc(db, 'subscriptions', docSnap.id);
                        updatePromises.push(updateDoc(subscriptionRef, {
                            PackingStatus: "Packed",
                            packedUser: currentUser ? currentUser.username : 'Unknown',
                        }));
                    });
                } else {
                    console.warn("No subscription found for this customer.");
                }
    
                // Execute all updates
                await Promise.all(updatePromises);
    
                // Update local state after Firestore update
                setBilledOrders(prevOrders =>
                    prevOrders.filter(o => o.id !== order.id)
                );
    
                setPackedOrders(prevOrders => [
                    ...prevOrders,
                    { ...order, PackingStatus: "Packed" }
                ]);
                fetchData();
                // Show success toast
                setToastMessage('Order and subscription status updated to Packed successfully');
                setToastVariant('success');
                setShowToast(true);
            }
        } catch (error) {
            console.error('Error updating order and subscription status:', error);
            setToastMessage('Error updating order and subscription status. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
    

    const handlePrintSlip = async (order) => {
        try {
            const storageRef = ref(storage, `deliverySlips/${order.customerId}_${order.schemeId}.pdf`);
            const deliverySlipURL = await getDownloadURL(storageRef);
            window.open(deliverySlipURL, '_blank');
        } catch (error) {
            console.error('Error fetching delivery slip:', error);
            setToastMessage('Error fetching delivery slip. Please try again.');
            setToastVariant('danger');
            setShowToast(true);
        }
    };
    const fetchContactDetails = async () => {
        try {
            const contactRef = doc(db, 'settings', 'contact');
            const contactDoc = await getDoc(contactRef);
            if (contactDoc.exists()) {
                setContactDetails(contactDoc.data());
            } else {
                console.log('No such document!');
            }
        } catch (error) {
            console.error('Error fetching contact details:', error);
        }
    };

    if (!scheme) {
    
            // Render loading screen
            return (
              <div className="loading-screen">
              <Loading/>
              </div>
            );
          
    }



    const sendNotificationToServer = async (fcmToken, customerName) => {
        try {
            await fetch("http://192.168.1.55:5000/api/send-notification", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ fcmToken, customerName })
            });
          } catch (error) {
            console.error("Error sending request to backend:", error);
        }
    };
    
    const handleDiscontinue = (customerId, discontinueData) => {
        console.log(customerId,discontinueData)
        setCustomers((prevCustomers) =>
            prevCustomers.map((customer) =>
                customer.cusmid === customerId
                    ? { ...customer, cusStatus: discontinueData.status, isActive: discontinueData.isActive, disProof: discontinueData.fileURL }
                    : customer
            )
        );
        fetchUnpaidCustomers();
    };

    const handlePriceRangeChange = (productId, priceRangeIndex) => {
        setSelectedPriceRanges(prevState => ({
            ...prevState,
            [productId]: priceRangeIndex
        }));
    };

    
    return (
        <Container fluid className="mt-5">
            <ToastAlert
                show={showToast}
                setShow={setShowToast}
                message={toastMessage}
                variant={toastVariant}
            />
            <h2>Billing & Packing</h2><hr/>
                <Row>
                    <Col>
                       
                        <h1>{scheme.name}</h1>
                        <h3>{scheme.id}</h3>
                        <p><strong>Onboarding Dates:</strong> {scheme.onboardingStart} to {scheme.onboardingEnd}</p>
                        <p><strong>Created Dates:</strong> {scheme.createdAt ? new Date(scheme.createdAt.seconds * 1000).toLocaleString() : 'Not Available'}</p>
                    </Col>
                   <Col className="text-end">
                      <Button variant='outline-success' className='m-2' onClick={syncData}>Sync</Button>
                                
                        <Button variant="outline-warning" onClick={handleShowAssignModal}>
                            Assign
                        </Button>
                    </Col>
                </Row>
                <Row>
                        <Col md={2} sm={2} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{customers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                        <h5 className="cus-head">Total customers</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={2} sm={2} className="mb-4">
                        <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{Unpaidcustomers.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Unpaid customers</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                     
                        <Col md={2} sm={2} className="mb-4">
                            <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{billedOrders.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                        <center>
                                            <h5 className="cus-head">Billed </h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                        </Col>
                        
                        <Col md={2} sm={2} className="mb-4">
                        <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{notPackedOrders.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Not packed</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                           
                        </Col>
                        <Col md={2} sm={2} className="mb-4">
                        <Card className="h-100">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <Card.Text>
                                        <h1 className="cus-count">{packedOrders.length}</h1>
                                    </Card.Text>
                                    <Card.Title>
                                    <center>
                                        <h5 className="cus-head">Packed</h5>
                                        </center>
                                    </Card.Title>
                                </Card.Body>
                            </Card>
                           
                        </Col>
                    </Row>
           
                    <Card className="h-100">
                    <Card.Body>
                        <h6>Products</h6>
                        <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            <Table striped bordered hover responsive>
                                <thead>
                                    <tr className='scheme-det-font-head'>
                                        <th>Product</th>
                                        <th>Measurement</th>
                                        <th>Quantity</th>
                                        <th>Stock</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.map((product) => (
                                        <tr key={product.id} className='scheme-det-font'>
                                            <td>{product.name}</td>
                                            <td>{product.unitValue} {product.unitType}</td>
                                            <td>{product.quantity}</td>
                                            
                                            <td>
                                                {product.priceRanges.map((priceRange, index) => (
                                                    <div key={index}>
                                                        Price: {priceRange.price}, Stock: {priceRange.stock}
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
             <br/>
            <Tabs
                id="process-customer"
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-3"
            >
                <Tab eventKey="paidcustomers" title="Paid customers">
                    <Card className="mb-4">
                        <Card.Body>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr className='scheme-det-font-head'>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Phone</th>
                                            <th>Billing</th>
                                            <th>Packing</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {paidcustomers.length > 0 ? (
                                    paidcustomers.map((paidcustomers, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{paidcustomers.cusmid}</td>
                                            <td>{paidcustomers.name}</td>
                                            <td>{paidcustomers.phone}</td>
                                            <td>{billingUsers.find(user => user.id === paidcustomers.billingUserId)?.username || 'Not Assigned'}</td>
                                            <td>{logisticsUsers.find(user => user.id === paidcustomers.logisticsUserId)?.username || 'Not Assigned'}</td>
                                            <td>
                                                <Button variant="outline-primary" className='btn btn'  onClick={() => handleShowModal(paidcustomers)}>
                                                   Genrate bill
                                                </Button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No customers found.</td>
                                    </tr>
                                )}
                                        {/* Add customer data here */}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Tab>
                <Tab eventKey="unpaidcustomers" title="Unpaid customers">
                    <Card className="mb-4">
                        <Card.Body>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive>
                                    <thead>
                                        <tr className='scheme-det-font-head'>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Phone</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {Unpaidcustomers.length > 0 ? (
                                    Unpaidcustomers.map((Unpaidcustomers, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{Unpaidcustomers.cusmid}</td>
                                            <td>{Unpaidcustomers.name}</td>
                                            <td>{Unpaidcustomers.phone}</td>
                                            <td>    
                                                {console.log(Unpaidcustomers.status)}                               
                                                {Unpaidcustomers.status === "discontinued" && !Unpaidcustomers.isActive ? (
                                                    <Button variant="outline-info" className="btn me-2" onClick={() => {
                                                        setProofUrl(Unpaidcustomers.discontinueData.fileURL);
                                                        setDisNotes(Unpaidcustomers.discontinueData.notes);
                                                        setFileModal(true);
                                                    }}>
                                                        Show Proof
                                                    </Button>
                                                ) : (
                                                    <Button variant="outline-warning" className="btn me-2" onClick={() => {
                                                        setSelectedCustomerDis(Unpaidcustomers.cusmid);
                                                        setShowDiscontinueModal(true);
                                                    }}>
                                                        Discontinue Scheme
                                                    </Button>
                                                )}
                                            </td>
                                        
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No customers found.</td>
                                    </tr>
                                )}
                                        {/* Add customer data here */}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Tab>
            </Tabs>
            <Tabs
                id="Process-order"
                activeKey={activeTab2}
                onSelect={(k) => setActiveTab2(k)}
                className="mb-3"
            >
                <Tab eventKey="billed" title="Billed">
                    <Card className="mb-4" >
                        <Card.Body>
                                <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                    <Table striped bordered hover responsive >
                                        <thead>
                                            <tr className='scheme-det-font-head'>
                                                <th>ID</th>
                                                <th>Customer ID</th>
                                                <th>Scheme ID</th>
                                                <th>Billing</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {billedOrders.length > 0 ? (
                                        billedOrders.map((order, index) => (
                                            <tr key={index} className='scheme-det-font'>
                                                <td>{order.invoiceNumber}</td>
                                                <td>{order.customerId}</td>
                                                <td>{order.schemeId}</td>
                                                <td>{order.billingUser}</td>
                                                <td>
                                                    {/* <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleShowNotesModal(order)}>
                                                    <FaNoteSticky/> Order Notes
                                                    </Button> */}
                                                    <Button variant="outline-secondary"style={{marginLeft:'5px'}} className='btn btn' onClick={() => handlePrintSlip(order)}>
                                                        <FaPrint/> Print Slip
                                                    </Button>
                                                    <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleMovePackOrder(order)}>
                                                        <FaBoxesPacking/> Mark as packed
                                                    </Button>
                                                </td>
                                            
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="5">No billed orders found.</td>
                                        </tr>
                                    )}
                                            {/* Add customer data here */}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Tab>
                <Tab eventKey="packed" title="Packed">
                    <Card className="mb-4" >
                        <Card.Body>
                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                <Table striped bordered hover responsive >
                                    <thead>
                                        <tr className='scheme-det-font-head'>
                                            <th>ID</th>
                                            <th>Customer ID</th>
                                            <th>Scheme ID</th>
                                            <th>billing</th>
                                            <th>Packing</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {packedOrders.length > 0 ? (
                                    packedOrders.map((order, index) => (
                                        <tr key={index} className='scheme-det-font'>
                                            <td>{order.id}</td>
                                            <td>{order.customerId}</td>
                                            <td>{order.schemeId}</td>
                                            <td>{order.billingUser}</td>
                                            <td>{order.packedUser}</td>
                                            <td>
                                                <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleShowNotesModal(order)}>
                                                <FaNoteSticky/> Order Notes
                                                </Button>
                                                <Button variant="outline-secondary"style={{marginLeft:'5px'}} className='btn btn' onClick={() => handlePrintSlip(order)}>
                                                    <FaPrint/> Print Slip
                                                </Button>
                                                {/* <Button variant="outline-primary" style={{marginLeft:'5px'}} className='btn btn' onClick={() => handleMovePackOrder(order)}>
                                                    <FaBoxesPacking/> Mark as packed
                                                </Button> */}
                                            </td>
                                        
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="5">No packed orders found.</td>
                                    </tr>
                                )}
                                        {/* Add customer data here */}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Tab>
                
            </Tabs>
          
            <Modal show={showModal} onHide={handleCloseModal} size='xl'>
    <Modal.Header closeButton>
        <Modal.Title>Customer Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {selectedCustomer && (
            <>
                <p><strong>Name:</strong> {selectedCustomer.name}</p>
                <p><strong>Email:</strong> {selectedCustomer.email}</p>
                <p><strong>Phone:</strong> {selectedCustomer.phone}</p>
                <p><strong>Address:</strong> {selectedCustomer.address.address}</p>
                <p><strong>Purchased quantity:</strong>{selectedCustomer.quantity}</p>
                <h5>Products</h5>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <Table responsive>
                        <thead>
                            <tr className='scheme-det-font-head'>
                                <th>Product Name</th>
                                <th>Barcode</th>
                                <th>Scanned Quantity</th>
                                <th>Total Quantity</th>
                                <th>Price Range</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalProducts.map((product, index) => (
                                <tr key={index}>
                                    <td>{product.name} - {product.unitValue} {product.unitType}</td>
                                    <td>
                                        <Form.Group className="">
                                            <Form.Control
                                                type="text"
                                                placeholder="Scan barcode"
                                                value={scannedBarcodes[product.id] || ''}
                                                onChange={(e) => handleBarcodeChange(product.id, e.target.value)}
                                            />
                                        </Form.Group>
                                    </td>
                                    <td>{scannedQuantities[product.id] || 0}</td>
                                    <td>{product.totalQuantity}</td>
                                    <td>
                                        <Form.Group className="">
                                            <Form.Control
                                                as="select"
                                                value={selectedPriceRanges[product.id] || ''}
                                                onChange={(e) => handlePriceRangeChange(product.id, e.target.value)}
                                            >
                                                <option value="" disabled>Select Price Range</option>
                                                {product.priceRanges.map((priceRange, index) => (
                                                    <option key={index} value={index}>
                                                        Price: {priceRange.price}, Stock: {priceRange.stock}
                                                    </option>
                                                ))}
                                            </Form.Control>
                                        </Form.Group>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                {barcodeError && <Alert variant="danger">{barcodeError}</Alert>}
            </>
        )}
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
            Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? <Loading /> : 'Generate bill'}
        </Button>
    </Modal.Footer>
</Modal>
   {/* <Modal show={showModal} onHide={handleCloseModal} size='lg'>
    <Modal.Header closeButton>
        <Modal.Title>Customer Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
        {selectedCustomer && (
            <>
                <p><strong>Name:</strong> {selectedCustomer.name}</p>
                <p><strong>Email:</strong> {selectedCustomer.email}</p>
                <p><strong>Phone:</strong> {selectedCustomer.phone}</p>
                <p><strong>Address:</strong> {selectedCustomer.address.address}</p>
                <p><strong>Purchased quantity:</strong>{selectedCustomer.quantity}</p>
                <h5>Products</h5>
                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <Table responsive>
                        <thead>
                            <tr className='scheme-det-font-head'>
                                <th>Product Name</th>
                                <th>Barcode</th>
                                <th>Scanned Quantity</th>
                                <th>Total Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalProducts.map((product, index) => (
                                <tr key={index}>
                                    <td>{product.name} - {product.unitValue} {product.unitType}</td>
                                    <td>
                                        <Form.Group className="">
                                            <Form.Control
                                                type="text"
                                                placeholder="Scan barcode"
                                                value={scannedBarcodes[product.id] || ''}
                                                onChange={(e) => handleBarcodeChange(product.id, e.target.value)}
                                            />
                                        </Form.Group>
                                    </td>
                                    <td>{scannedQuantities[product.id] || 0}</td>
                                    <td>{product.totalQuantity}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
                {barcodeError && <Alert variant="danger">{barcodeError}</Alert>}
            </>
        )}
    </Modal.Body>
    <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
            Close
        </Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? <Loading /> : 'Generate bill'}
        </Button>
    </Modal.Footer>
</Modal> */}
            <Modal show={showNotesModal}  onHide={handleCloseNotesModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Order Notes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={orderNotes}
                            onChange={(e) => setOrderNotes(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Tracking Link</Form.Label>
                        <Form.Control
                            type="text"
                            value={trackingLink}
                            onChange={(e) => setTrackingLink(e.target.value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Upload Slip</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(e) => {
                                setUploadedSlip(e.target.files[0]);
                                setUploadedSlipURL(URL.createObjectURL(e.target.files[0]));
                            }}
                        />
                    </Form.Group>
                    {uploadedSlipURL && (
                        <div className="mb-3">
                            <Form.Label>Uploaded Slip Preview</Form.Label>
                            <img src={uploadedSlipURL} alt="Uploaded Slip" style={{ width: '100%', height: 'auto' }} />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" className='btn btn' onClick={handleCloseNotesModal}>
                        Close
                    </Button>
                    <Button variant="outline-success" className='btn btn' onClick={handleNotesSubmit}>
                        Submit
                    </Button>
                </Modal.Footer>
            </Modal>
          
                        <Modal show={showAssignModal} onHide={handleCloseAssignModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Assign Users</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Completed Users</Form.Label>
                        <Form.Control
                            as="select"
                            multiple
                            value={selectedCompletedUsers}
                            onChange={(e) => setSelectedCompletedUsers(Array.from(e.target.selectedOptions, option => option.value))}
                        >
                            {paidcustomers.map(user => (
                                <option key={user.cusmid} value={user.cusmid}>{user.name}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Billing Person</Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedBillingUser}
                            onChange={(e) => setSelectedBillingUser(e.target.value)}
                        >
                            <option value="">Select Billing Person</option>
                            {billingUsers.map(user => (
                                <option key={user.id} value={user.id}>{user.username}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Logistics Person</Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedLogisticsUser}
                            onChange={(e) => setSelectedLogisticsUser(e.target.value)}
                        >
                            <option value="">Select Logistics Person</option>
                            {logisticsUsers.map(user => (
                                <option key={user.id} value={user.id}>{user.username}</option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" className='btn btn' onClick={handleCloseAssignModal}>
                        Close
                    </Button>
                    <Button variant="outline-success" className='btn btn' onClick={handleAssignSubmit}>
                        Assign
                    </Button>
                </Modal.Footer>
            </Modal>
            <DiscontinueSchemeModal
                show={showDiscontinueModal}
                onHide={() => setShowDiscontinueModal(false)}
                schemeId={id}
                customerId={selectedCustomerDis}
                onDiscontinue={handleDiscontinue}
            />
            <FileViewModal
            show={showFileModal}
            onHide={()=> setFileModal(false)}
            fileUrl={proofUrl}
            notes={disNotes}
            />
            {/* <Button variant="outline-info" onClick={handlePreviewPDF}>
    Preview Delivery Challan
</Button> */}
        </Container>
    );
};

export default ProcessScheme;